import { availableTypes, currentIconSubdirectoryName, caviarIcons, doordashIcons } from '../themes/availableIcons.js';
import { createIconColors } from './utils.js';
import { Brands } from '../theming/constants.js';

var _BRAND_NAMES, _URL_FOR_BRAND;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alphabetizedTypes = function alphabetizedTypes(typesObj) {
  var availableObject = {};
  var typeNames = [];
  Object.keys(typesObj).forEach(function (typeName) {
    typeNames.push(typeName);
  });
  typeNames.sort();
  typeNames.forEach(function (name) {
    availableObject[name] = name;
  });
  return availableObject;
};

var IconSize = {
  Tiny: 12,
  Small: 16,
  Medium: 24,
  Large: 32,
  XLarge: 48,
  XxLarge: 64,
  XxxLarge: 96,
  Huge: 128
};
var IconColor = createIconColors();
var IconType = alphabetizedTypes(availableTypes.DoorDash);
var BRAND_NAMES = (_BRAND_NAMES = {}, _defineProperty(_BRAND_NAMES, Brands.Caviar, 'Caviar'), _defineProperty(_BRAND_NAMES, Brands.DoorDash, 'DoorDash'), _defineProperty(_BRAND_NAMES, "Caviar", 'Caviar'), _defineProperty(_BRAND_NAMES, "DoorDash", 'DoorDash'), _BRAND_NAMES);
var DEFAULT_BRAND = BRAND_NAMES.DoorDash;
var URL_FOR_BRAND = (_URL_FOR_BRAND = {}, _defineProperty(_URL_FOR_BRAND, BRAND_NAMES.Caviar, 'caviar/'), _defineProperty(_URL_FOR_BRAND, BRAND_NAMES.DoorDash, 'default/'), _URL_FOR_BRAND);
var svgSourceBaseUrl = "https://s3-design-language-system.cdn4dd.com/icons/".concat(currentIconSubdirectoryName, "/");
var availableIcons = {
  Caviar: caviarIcons,
  DoorDash: doordashIcons
};

export { BRAND_NAMES, DEFAULT_BRAND, IconColor, IconSize, IconType, URL_FOR_BRAND, availableIcons, svgSourceBaseUrl };
